export const formatData = (source, selectCandidate) => {
    const data = JSON.parse(JSON.stringify(source));
    return new Promise(resolve => {
        let column1 = [];
        let column2 = [];
        if (data) {
            const columns = data['columns'];
            if (selectCandidate) {
                columns['column-1'].orderIds.forEach(item => {
                    if (item !== 1) {
                        column1.push(item);
                    }
                });
                if (columns['column-2'].orderIds.includes('1')) {
                    column2 = [...new Set(columns['column-2'].orderIds)];
                } else {
                    const ids = ['1', ...columns['column-2'].orderIds]
                    column2 = [...new Set(ids)];
                }
            } else {
                if (columns['column-2'].orderIds.includes('1')) {
                    const ind = columns['column-2'].orderIds.indexOf('1');
                    columns['column-2'].orderIds.splice(ind, 1);
                    column2 = [...new Set(columns['column-2'].orderIds)];
                    const ids = [1, ...columns['column-1'].orderIds];
                    column1 = [...new Set(ids)];
                } else {
                    column1 = [...new Set(columns['column-1'].orderIds)];
                    column2 = [...new Set(columns['column-2'].orderIds)];
                }
            }
        }
        resolve({
            ...data,
            columns: {
                'column-1': {
                    id: 'column-1',
                    title: 'Release Order',
                    orderIds: column1,
                },
                'column-2': {
                    id: 'column-2',
                    title: 'Selected Release Order',
                    orderIds: column2,
                },
            },
        });
        return
    });
}


export const formatFirstTime = (shiftReleaseOderList, savedJobShiftReleaseOrderIds) => {
    let objWithId = {}
    let column1 = shiftReleaseOderList?.map(item => item.jobShiftReleaseOrderId);;
    if (savedJobShiftReleaseOrderIds?.length) {
        savedJobShiftReleaseOrderIds.forEach(item => {
            if (column1.includes(parseInt(item))) {
                const ind = column1.indexOf(parseInt(item));
                column1.splice(ind, 1);
            }
        })
    }
    shiftReleaseOderList.forEach(item => {
        objWithId[item.jobShiftReleaseOrderId] = item
    });
    const formatData = {
        orderList: objWithId,
        columns: {
            'column-1': {
                id: 'column-1',
                title: 'Release Order',
                orderIds: column1,
            },
            'column-2': {
                id: 'column-2',
                title: 'Selected Release Order',
                orderIds: savedJobShiftReleaseOrderIds?.length ? savedJobShiftReleaseOrderIds : [],
            },
        },
        columnOrder: ['column-1', 'column-2'],
    }
    return formatData;
}
